interface Props {
  color?: string;
  className?: string;
  size?: 'small';
}

export default function InflGlobusSvg(props: Props) {
  switch (props.size) {
    case 'small':
      return (
        <svg
          className={props.className}
          width='16'
          height='16'
          viewBox='0 0 16 16'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'>
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M9.20785 12.3458C8.72302 13.3463 8.25486 13.5 8 13.5C7.74514 13.5 7.27698 13.3463 6.79215 12.3458C6.41987 11.5776 6.14494 10.4877 6.04314 9.15864C6.67634 9.21865 7.33101 9.24997 8 9.24997C8.66899 9.24997 9.32366 9.21865 9.95686 9.15864C9.85506 10.4877 9.58013 11.5776 9.20785 12.3458ZM9.99615 7.6473C9.35796 7.71422 8.68967 7.74997 8 7.74997C7.31033 7.74997 6.64204 7.71422 6.00385 7.6473C6.04121 5.95052 6.34713 4.57247 6.79215 3.65416C7.27698 2.65372 7.74514 2.5 8 2.5C8.25486 2.5 8.72302 2.65372 9.20785 3.65416C9.65287 4.57247 9.95879 5.95052 9.99615 7.6473ZM11.4737 8.95347C11.3885 10.4685 11.0989 11.8012 10.6384 12.8271C12.216 11.9629 13.3237 10.3479 13.4808 8.46288C12.8595 8.66166 12.1863 8.82671 11.4737 8.95347ZM13.3919 6.9095C12.8199 7.11447 12.1813 7.28863 11.4905 7.42434C11.435 5.75296 11.1368 4.28328 10.6384 3.17295C12.0378 3.93948 13.0675 5.29687 13.3919 6.9095ZM4.50947 7.42434C4.56501 5.75296 4.86321 4.28328 5.36164 3.17295C3.96219 3.93948 2.93247 5.29687 2.6081 6.90951C3.18009 7.11448 3.81871 7.28863 4.50947 7.42434ZM2.5192 8.46288C2.67628 10.3479 3.78403 11.9629 5.36164 12.8271C4.90112 11.8012 4.61153 10.4685 4.52633 8.95347C3.81369 8.82671 3.14052 8.66166 2.5192 8.46288ZM15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8Z'
            fill={props.color || 'currentColor'}
          />
        </svg>
      );
    default:
      return (
        <svg
          className={props.className}
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'>
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M14.2167 18.715C13.4532 20.2905 12.6289 20.7 12 20.7C11.3711 20.7 10.5468 20.2905 9.78327 18.715C9.16495 17.4391 8.72991 15.6364 8.59458 13.4632C9.68793 13.5855 10.8288 13.65 12 13.65C13.1712 13.65 14.3121 13.5855 15.4054 13.4632C15.2701 15.6364 14.835 17.4391 14.2167 18.715ZM15.4475 11.6462C14.3533 11.7786 13.1974 11.85 12 11.85C10.8026 11.85 9.64672 11.7786 8.55253 11.6462C8.59086 8.97507 9.06255 6.77219 9.78327 5.28499C10.5468 3.70946 11.3711 3.3 12 3.3C12.6289 3.3 13.4532 3.70946 14.2167 5.28499C14.9374 6.77219 15.4091 8.97507 15.4475 11.6462ZM17.2224 13.1995C17.0954 15.9168 16.5346 18.2579 15.6239 19.9116C18.5345 18.5762 20.5812 15.6819 20.695 12.2976C19.6419 12.6697 18.4741 12.9743 17.2224 13.1995ZM20.5585 10.4287C19.5814 10.8086 18.4645 11.1264 17.2423 11.3645C17.1706 8.4074 16.597 5.85542 15.6239 4.08835C18.1618 5.25276 20.0429 7.60244 20.5585 10.4287ZM6.75765 11.3645C6.82939 8.40739 7.40296 5.85542 8.3761 4.08835C5.83815 5.25276 3.95706 7.60244 3.44152 10.4287C4.41855 10.8086 5.5355 11.1264 6.75765 11.3645ZM3.30499 12.2976C3.41875 15.6819 5.46545 18.5763 8.37611 19.9116C7.46539 18.2579 6.90462 15.9168 6.77763 13.1995C5.52586 12.9743 4.35814 12.6697 3.30499 12.2976ZM22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12Z'
            fill={props.color || 'currentColor'}
            fill-opacity='0.85'
          />
        </svg>
      );
  }
}
